export class MappingInfos {
    /**
     * Dictionnaire contenant les relations entre les id des elements du workflow trigger et l'id du noeud correspondant.
     */
    public triggerNodeIdMappings: Map<number, string> = new Map<number, string>();

    /**
     * Dictionnaire contenant les relations entre les id des elements du workflow action et l'id du noeud correspondant.
     */
    public actionNodeIdMappings: Map<number, string> = new Map<number, string>();

    /**
     * Dictionnaire contenant les relations entre les id des elements du workflow action et l'id du noeud étape et de l'input correspondant.
     */
    private stepActionNodeIdMappings: Map<string, number> = new Map<string, number>();

    /**
     * Dictionnaire contenant les relations entre les id des elements du workflow trigger et l'id du noeud étape et de l'output correspondant.
     */
    private stepTriggerNodeIdMappings: Map<string, number> = new Map<string, number>();

    /**
     * Dictionnaire contenant les relations entre les id des elements du workflow step et l'id du noeud correspondant.
     */
    public stepNodeIdMappings: Map<string, number> = new Map<string, number>();

    public getNodeTriggerId(nodeId: string): number {
        for (let [key, value] of this.triggerNodeIdMappings.entries()) {
            if (value === nodeId) {
                return key;
            }
        }
        throw new Error(`Aucun trigger n'a été trouvé pour le noeud \'${nodeId}\'`);
    }

    public getNodeActionId(nodeId: string): number {
        for (let [key, value] of this.actionNodeIdMappings.entries()) {
            if (value === nodeId) {
                return key;
            }
        }
        throw new Error(`Aucune action n'a été trouvé pour le noeud \'${nodeId}\'`);
    }

    public getStepNodeActionId(nodeId: string, inputSocketCode: string) {
        let key: string = `${nodeId} - ${inputSocketCode}`;
        return this.stepActionNodeIdMappings.get(key);
    }

    public setStepNodeActionId(nodeId: string, inputSocketCode: number, actionId: number) {
        let key: string = `${nodeId} - ${inputSocketCode}`;
        return this.stepActionNodeIdMappings.set(key, actionId);
    }

    public getStepNodeTriggerId(nodeId: string, outputSocketCode: string) {
        let key: string = `${nodeId} - ${outputSocketCode}`;
        return this.stepTriggerNodeIdMappings.get(key);
    }

    public setStepNodeTriggerId(nodeId: string, outputSocketCode: number, triggerId: number) {
        let key: string = `${nodeId} - ${outputSocketCode}`;
        return this.stepTriggerNodeIdMappings.set(key, triggerId);
    }

    /**
     * Retourne l'id du noeud de type Etape correspondant à l'id d'étape spécifié.
     * @param stepId : Id de l'étape.
     * @returns : L'id du noeud correspondant.
     */
    public getStepNodeIdByStepId(stepId: number) {
        for (let [key, value] of this.stepNodeIdMappings.entries()) {
            if (value === stepId) return key;
        }
        return null;
    }
}
